/* ============================================================
   BUY BOX CRO JS - Karar Store
   Savings badge + COD line, all products, variant-aware
   Fixed: price parsing (Rs. prefix dot bug)
   ============================================================ */

(function () {
  'use strict';

  if (window.location.pathname.indexOf('/products/') === -1) return;

  // Extract the actual number: matches "3,000.00" inside "Rs.3,000.00 PKR"
  function parsePrice(el) {
    if (!el) return null;
    var m = el.textContent.match(/([0-9][0-9,]*(?:\.[0-9]{1,2})?)/);
    if (!m) return null;
    var val = parseFloat(m[1].replace(/,/g, ''));
    return isNaN(val) ? null : val;
  }

  function fmt(n) {
    return 'Rs. ' + Math.round(n).toLocaleString();
  }

  function updateSavings() {
    var priceWrap = document.querySelector('.price--on-sale');
    var badge = document.getElementById('cro-savings');

    if (!priceWrap) {
      if (badge) badge.style.display = 'none';
      return;
    }

    var compareEl = priceWrap.querySelector('.price__sale .price-item--regular');
    var saleEl = priceWrap.querySelector('.price-item--sale');
    var compare = parsePrice(compareEl);
    var sale = parsePrice(saleEl);

    if (!compare || !sale || compare <= sale) {
      if (badge) badge.style.display = 'none';
      return;
    }

    var saving = compare - sale;
    var pct = Math.round((saving / compare) * 100);

    if (!badge) {
      badge = document.createElement('div');
      badge.className = 'cro-savings';
      badge.id = 'cro-savings';
      var priceContainer = document.querySelector('.product__info-container .price, [id^="ProductInfo-"] .price');
      if (priceContainer) priceContainer.insertAdjacentElement('afterend', badge);
      else return;
    }
    badge.style.display = 'inline-flex';
    badge.textContent = 'You save ' + fmt(saving) + ' (' + pct + '% OFF)';
  }

  function addCODLine() {
    if (document.querySelector('.cro-cod-line')) return;
    var buttons = document.querySelector('.product-form__buttons');
    if (!buttons) return;
    var line = document.createElement('div');
    line.className = 'cro-cod-line';
    line.innerHTML = '<svg viewBox="0 0 24 24" fill="currentColor"><path d="M12 2C6.48 2 2 6.48 2 12s4.48 10 10 10 10-4.48 10-10S17.52 2 12 2zm-2 15l-5-5 1.41-1.41L10 14.17l7.59-7.59L19 8l-9 9z"/></svg>Cash on Delivery available nationwide';
    buttons.insertAdjacentElement('afterend', line);
  }

  function init() {
    var tries = 0;
    var interval = setInterval(function () {
      var priceEl = document.querySelector('[id^="ProductInfo-"] .price');
      if (priceEl || tries > 25) {
        clearInterval(interval);
        if (priceEl) {
          updateSavings();
          addCODLine();
        }
      }
      tries++;
    }, 200);

    document.addEventListener('variant:changed', function () {
      setTimeout(updateSavings, 100);
    });

    var observed = false;
    var obsInterval = setInterval(function () {
      var p = document.querySelector('[id^="ProductInfo-"] .price');
      if (p && !observed) {
        observed = true;
        clearInterval(obsInterval);
        new MutationObserver(function () {
          updateSavings();
        }).observe(p, { childList: true, subtree: true, characterData: true, attributes: true });
      }
    }, 400);
  }

  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', init);
  else init();

})();
